import React, { useState, useEffect, useCallback, useContext } from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { doc, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import { useFirestore } from "../firebase/FirestoreContext"; // Use Firestore context
import { UserContext } from "../context/UserContext";
import { useParams } from "react-router-dom";

const AddToFavorites = ({ productId }) => {
  const { user } = useContext(UserContext);
  const db = useFirestore();
  const [isFavorite, setIsFavorite] = useState(null);

  const { listingID } = useParams();

  const addToFavorite = useCallback(async () => {
    if (!user) {
      alert("Please sign in to add to favorites.");
      return;
    }
    try {
      //Verifies the current state
      const favoriteRef = doc(
        db,
        `Users/UsersList/DataBase/${user.uid}/FavoriteProducts`,
        listingID
      );
      const favoriteDoc = await getDoc(favoriteRef);

      //If its currently in favorites we unfavorite it
      if (favoriteDoc.exists()) {
        await deleteDoc(favoriteRef);

        setIsFavorite(null);
      } else {
        //If is not in favorites. We add it
        await setDoc(favoriteRef, {
          product_id: productId,
          date: new Date(),
        });
        setIsFavorite(1);
      }
    } catch (error) {
      console.error("Error adding/removing to favorites:", error);
    }
  }, [db, user, productId]);

  useEffect(() => {
    if (user) {
      const favoriteRef = doc(
        db,
        `Users/UsersList/DataBase/${user.uid}/FavoriteProducts`,
        listingID
      );
      getDoc(favoriteRef).then((doc) => {
        if (doc.exists()) {
          setIsFavorite(1);
        } else {
          setIsFavorite(null);
        }
      });
    }
  }, [user, productId, listingID]);

  return (
    <LikeShareContainer>
      <LikeShareRow>
        <LikeButton>
          <FontAwesomeIcon
            icon={isFavorite ? faHeart : farHeart}
            css={{ color: "black", marginRight: "5px", fontSize: "20px" }}
            onClick={addToFavorite}
          />
          {isFavorite && (
            <AddedToFavoritesText>Added to favorites</AddedToFavoritesText>
          )}
        </LikeButton>
      </LikeShareRow>
    </LikeShareContainer>
  );
};

export default AddToFavorites;

const LikeShareContainer = styled.div`
  padding: 20px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (min-width: 755px) {
    padding-top: 0;
    justify-content: flex-end;
  }
`;

const LikeShareRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const LikeButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 3px;
  position: relative;
`;

const AddedToFavoritesText = styled.div`
  position: absolute;
  right: 7px;
  top: 25px;
  text-align: right;
  font-size: 0.7rem;
  color: gray;
  white-space: nowrap;
  @media (min-width: 755px) {
    font-size: 1rem;
  }
`;
